import {RemoteGetFavoritePlaces} from "data/usecases";
import {GetFavoritePlaces} from "domain/usecases";
import {makeAuthorizeHttpClientDecorator} from "main/factories/decorators";
import {makeBFFApiUrl} from "main/factories/http";
import {GuideFlowEndpoints} from "main/factories/usecases/endpoints";

export const makeGetFavoritePlaces = (): GetFavoritePlaces =>
  new RemoteGetFavoritePlaces(
    makeBFFApiUrl(GuideFlowEndpoints.medicalFavoritePlace),
    makeAuthorizeHttpClientDecorator(),
  );
